var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards-container"},_vm._l((_vm.assets),function(asset){return _c('asset',{key:asset.id,attrs:{"assetId":asset.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }